import React from 'react';
import Icon from '../components/core/Icon';
export function getStarHtml(star, size=20){
  return <span className='star'>
    <Icon name='star' style={{color:(star>=1?'gold':'#c5c5c5'),width:size,height:size}} width={size} height={size} value={star>=1?1:0}/>
    {star<1&&star>0?<Icon name='star'style={{color:'gold',width:size,height:size}} width={star*size} height={size}/>:''}
  </span>
}
